import HttpClient from '@/utils/HttpClient';
import projectStore from '@/store/Projects';
const utils = require('../utils/formatting');

export default {
  getProjects() {
    return HttpClient.getAuthenticated(`/api/projects`);
  },
  getActiveProject() {
    return HttpClient.getAuthenticated(`/api/projects/lastproject`);
  },
  create(project) {
    return HttpClient.postAuthenticated(`/api/projects`, { project });
  },
  update(project) {
    var projectToPatch = { ...project }; // create a copy, so we can delete the picture field from the object
    delete projectToPatch.ProjectPicture;
    project.ProjectStartDateSQL = utils.browserDateToSQLDate(project.ProjectStartDate);
    return HttpClient.updateAuthenticated(`/api/projects/${projectStore.activeProject.DbId}`, { project });
  },
  start() {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/start`);
  },
  archive() {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/archive`);
  },
  unarchive() {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/unarchive`);
  },
  end() {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/end`);
  },
  abortEnd() {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/end/abort`);
  },
  revertStart() {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/revertstart`);
  },
  getProjectSettings() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/settings`);
  },
  updateProjectSettings(settings) {
    const newArray = [];
    for (const entry in settings) {
      const setting = { key: entry, value: settings[entry] };
      newArray.push(setting);
    }
    return HttpClient.updateAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/settings`, {
      settings: newArray
    });
  },
  getProjectPicture() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/picture`);
  },
  updateProjectPicture(picture) {
    return HttpClient.updateAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/settings/picture`, {
      picture
    });
  },
  tryDeletePATField(index) {
    return HttpClient.deleteAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/settings/fields/${index}`);
  },
  getZFIndex() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/index`);
  },
  inviteUser(firstName, lastName, email, project) {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/inviteUser`, {
      firstName,
      lastName,
      email,
      project
    });
  },
  getUsersByProject() {
    //return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/users`);

    return new Promise((resolve, reject) => {
      return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/users`)
        .then(result => {
          result.map(x => {
            x.text = x.Name;
            x.subtext = x.UserId;
            x.icon = x.InviteAccepted == 0 ? 'clock-history' : null;
            x.IsAdmin = x.IsAdmin == 'true' ? true : false;
            x.IsPlaner = x.IsPlaner == 'true' ? true : false;
            x.IsSuperAdmin = x.IsSuperAdmin == 'true' ? true : false;
            return x;
          });
          resolve(result);
        })
        .catch(err => reject(err));
    });
  },
  getACLUsersByProject__() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/aclusers`);
  },
  addACLUser(userId, role) {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/aclusers`, {
      userId,
      role
    });
  },
  updateACLUser(userId, role) {
    return HttpClient.updateAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/aclusers`, {
      userId,
      role
    });
  },
  deleteACLUser(userId) {
    return HttpClient.deleteAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/aclusers`, { userId });
  },
  deleteProjectUser(userId) {
    return HttpClient.deleteAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/users`, { userId });
  }
};
